import {SimpleGrid} from "@chakra-ui/react";
import * as React from "react";
import {OverviewCard,OverviewCardProps} from "./overview-card";
import {
  StatSectionWrapperProps,
  StatsSectionWrapper
} from "./stats-section-wrapper";
export interface OverviewStatSectionProps
  extends Omit<StatSectionWrapperProps, "children"> {
  title: string;
  subtitle: string;
  stats: OverviewCardProps[];
  colorScheme?: string;
}
export const OverviewStatSection: React.FC<OverviewStatSectionProps> = ({
  stats,
  title,
  subtitle,
  colorScheme,
}) => {
  return (
    <StatsSectionWrapper {...{ title, subtitle, colorScheme }}>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing="6">
        {stats.map((stat: OverviewCardProps, id: number) => (
          <OverviewCard key={id} {...stat} />
        ))}
      </SimpleGrid>
    </StatsSectionWrapper>
  );
};
